import {AkmeDataPartition} from './AkmeDataPartition';
import {FileConfiguration} from '../../file/message/FileConfiguration';
import {SqlParam} from '../../sql/message/SqlParam';

export class CnxPartitioner {
akmeData: AkmeDataPartition;
corePoolSize: number | null;
file: FileConfiguration;
keepAliveSeconds: number | null;
kind: string;
multithread: boolean | boolean;
query: string;
queryParams: SqlParam[];
sort: boolean | null;
}

